import type { PlanningChecklist, PlanningSession } from './types';

export function planningChecklistFromRow(row: any): PlanningChecklist {
  return {
    id: row.id,
    teamId: row.team_id ?? undefined,
    cycleType: row.cycle_type,
    year: row.year ?? 0,
    quarter: row.quarter ?? undefined,
    items: Array.isArray(row.items) ? row.items : [],
  };
}

export function planningSessionFromRow(row: any): PlanningSession {
  return {
    id: row.id, workspaceId: row.workspace_id,
    teamId: row.team_id ?? undefined, kind: row.kind,
    year: row.year ?? undefined, quarter: row.quarter ?? undefined,
    prevYear: row.prev_year ?? undefined, prevQuarter: row.prev_quarter ?? undefined,
    startedAt: row.started_at, completedAt: row.completed_at ?? undefined,
    facilitatorId: row.facilitator_id ?? undefined, notes: row.notes ?? undefined,
  };
}
